import React from "react";

export interface IMaterialSwatchProps {
    className?: string;
    color?: string;
    imageSrc?: string;
}

export const MaterialSwatch: React.VFC<IMaterialSwatchProps> = (props) => {
    const className = `material-swatch ${props.className}`;

    return !!props.imageSrc
        ? <img className={className} loading="lazy" src={props.imageSrc} />
        : <div className={className} role="img" style={{backgroundColor: props.color}}></div>
}
